import React, { useEffect, useState } from 'react'
import { ActivityLogsRecentData } from '../../../services'
import { Clock, Activity } from 'lucide-react'

function ActivityLogsRecent() {
  const [recentActivity, setRecentActivity] = useState([])
  const [loading, setLoading] = useState(true)

  const activityData = async () => {
    try {
      setLoading(true)
      const res = await ActivityLogsRecentData()
      setRecentActivity(res)
    } catch (error) {
      console.error('Error fetching activity logs:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    activityData()
  }, [])

  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6 mb-6">
        <div className="animate-pulse">
          <div className="h-6 bg-gray-200 rounded w-1/3 mb-4"></div>
          <div className="space-y-3">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="h-20 bg-gray-200 rounded"></div>
            ))}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 p-6 mb-6 border border-gray-100">
      <div className="flex items-center mb-6">
        <div className="bg-gradient-to-r from-pink-500 to-rose-500 p-3 rounded-lg mr-4">
          <Clock className="w-6 h-6 text-white" />
        </div>
        <div>
          <h2 className="text-xl font-bold text-gray-800">Recent Activities</h2>
          <p className="text-sm text-gray-500">Latest user activities on your platform</p>
        </div>
      </div>

      {recentActivity.length === 0 ? (
        <div className="text-center py-12">
          <div className="bg-gray-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
            <Activity className="w-8 h-8 text-gray-400" />
          </div>
          <p className="text-gray-500">No recent activity logs found</p>
        </div>
      ) : (
        <div className="space-y-3">
          {recentActivity.map((item, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-lg p-4 hover:bg-gradient-to-r hover:from-pink-50 hover:to-rose-50 transition-all duration-200 hover:border-pink-300"
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center space-x-2 mb-2">
                    <span className="px-3 py-1 bg-gradient-to-r from-pink-500 to-rose-500 text-white rounded-full text-xs font-medium">
                      {item.activity_type || 'N/A'}
                    </span>
                    <span className="text-xs text-gray-500">
                      {item.timestamp ? new Date(item.timestamp).toLocaleString() : ''}
                    </span>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-sm">
                    <div>
                      <span className="text-gray-500">User:</span>
                      <p className="text-gray-800 font-medium truncate">{item.user_email || 'N/A'}</p>
                    </div>
                    <div>
                      <span className="text-gray-500">Location:</span>
                      <p className="text-gray-800 font-medium">{item.city || 'N/A'}</p>
                    </div>
                    <div>
                      <span className="text-gray-500">IP:</span>
                      <p className="text-gray-800 font-mono text-xs">{item.ip || 'N/A'}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {recentActivity.length > 0 && (
        <div className="mt-6 pt-4 border-t border-gray-200 text-center">
          <span className="text-sm text-gray-500">
            Showing {recentActivity.length} recent activities
          </span>
        </div>
      )}
    </div>
  )
}

export default ActivityLogsRecent